export const MAX_VAT_TREE_LEVEL = 8;

export const isDepthLimitReached = (node: {depth: number; data: {forExpand?: boolean}}) =>
    !node.data.forExpand && node.depth >= MAX_VAT_TREE_LEVEL - 1;
